import { TripChecklistTab } from '../components/TripChecklistTab';

export function TodoTab({ tripId }: { tripId: string }) {
  return (
    <TripChecklistTab
      tripId={tripId}
      kind="todo"
      templateSectionTitle="Add to-do list from template"
      templateDescription="Templates stay unchanged — items are copied into this trip only."
      emptyMessage="No to-do lists on this trip yet. Pick a template above."
      addPlaceholder="Add task…"
      sectionLabels={{ open: 'To do', done: 'Done' }}
    />
  );
}
